import { useRouter } from "next/router";
import { textPayment } from "../../src/components/MockData/MockData";
import ClientLayout from "../../src/layouts/client/ClientLayout";
import ccImg from '../../src/assets/images/paymentIcon/credit-card.png'
import ppImg from '../../src/assets/images/paymentIcon/prompt-pay.png'
import bankImg from '../../src/assets/images/paymentIcon/bank.png'
import bankImgmb from '../../src/assets/images/paymentIcon/bank-mb.png'
import MetaHeader from "../../src/components/MetaHeader";
import { textConfig } from "../../constants/textLang";

const PaymentMethods = () => {
    const router = useRouter()
    const { locale } = router
    return (
        <ClientLayout style={{ backgroundColor: 'black' }}>
            <section className="payment-methods-content">
                <div className="content-footer-wrapper">
                    <div className="header-title">
                        <h1>{textPayment[locale].head_title}</h1>
                    </div>
                    <div className="main-content-text">
                        <div className="text-top">
                            <p>{textPayment[locale].line_one}</p>
                        </div>
                        <div className="icon">
                            <img alt="credit-card" src={ccImg.src} className='cc-img' />
                            <p>{textPayment[locale].cc}</p>
                        </div>
                        <div className="text-detail">
                            <p>{textPayment[locale].line_two}</p>
                        </div>
                        <div className="icon-bank">
                            <img alt='bank' src={bankImg.src} className='bank-img' />
                            <img alt='bank-mb' src={bankImgmb.src} className='bank-img-mb' />
                        </div>
                        <div className="icon-pp">
                            <img alt='prompt-pay' src={ppImg.src} className='prompt-pay-img' />
                            <p>{textPayment[locale].pp}</p>
                        </div>
                        <div className="text-bottom">
                            <p>{textPayment[locale].line_three}</p>
                        </div>
                    </div>
                </div>
            </section>
        </ClientLayout>
    )
}

export const getStaticProps = async (ctx) => {
    const { locale } = ctx
    const meta = {
        title: textConfig[locale]?.title_payment,
        keywords: textConfig[locale]?.text_keyword,
        description: 'Luxury29 Car Rental Payment Methods Page',
        image: 'main-pic.jpeg'
    };

    return {
        props: { meta },
    };
};

export default MetaHeader(PaymentMethods);